import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Mixins } from "@/assets/scripts/mixins";
import i18n from './i18n'

Vue.config.productionTip = false

/* Mixins - add functions that are available in all components
-------------------------------------------------- */
Vue.mixin(Mixins)

/* Global elements
-------------------------------------------------- */
import inputComponent from '@/components/Forms/InputGroup.vue'
import buttonComponent from '@/components/Buttons/Button.vue'

/* Global components
-------------------------------------------------- */
Vue.component('f-input', inputComponent)
Vue.component('f-button', buttonComponent)

/* Initialize app
-------------------------------------------------- */

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
